import { NgModule } from '@angular/core';
import { AtpNotificationsComponent } from './atp-notifications.component';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { AtpNotificationsService } from './atp-notifications.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { AtpNotificationComponent } from './atp-notification.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    AtpNotificationsComponent,
    AtpNotificationComponent
  ],
  imports: [
    CommonModule,
    PortalModule,
    OverlayModule,
    RouterModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    AtpNotificationsComponent,
    AtpNotificationComponent
  ],
  providers: [
    AtpNotificationsService
  ]
})
export class AtpNotificationsModule {
}